export const contentBlockTypes = [
    'Accordion',
    'AccountManager',
    'Assets',
    'Carousel',
    'Categories',
    'CtaLink',
    'ImageContentLink',
    'ImageHeader',
    'ImageWithTextHeader',
    'ImageMosaic',
    'ImageText',
    'ImageWithText',
    'Form',
    'Map',
    'NewsLetter',
    'PageLinks',
    'Paragraphs',
    'ParagraphsCarousel',
    'ProjectShowCase',
    'Quotes',
    'Statistics',
    'SubFooterLink',
    'TextHeader',
    'UniqueSellingPoints',
    'VideoHeader',
    'VideoText',
    'VideoWithText',
]
